export default {
  barTitle: 'Informasjonskapsler',
  barDescription:
    'Vi bruker våre egne informasjonskapsler og tredjeparts informasjonskapsler, slik at vi kan vise deg dette nettstedet og bedre forstå hvordan du bruker det, med tanke på å forbedre tjenestene vi tilbyr.',
  acceptAll: 'Godta alle',
  declineAll: 'Slett alle',
  manageCookies: 'Administrer informasjonskapsler',
  unsaved: 'Du har ulagrede innstillinger',
  close: 'Lukk',
  save: 'Lagre',
  necessary: 'Nødvendige informasjonskapsler',
  optional: 'Valgfrie informasjonskapsler',
  functional: 'Funksjonelle informasjonskapsler',
  blockedIframe:
    'For å se dette, vennligst aktiver funksjonelle informasjonskapsler',
  here: 'her'
}
